module.exports = __webpack_public_path__ + "static/Bakary.5b85438d.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team/Bakary.jpeg
// module id = 933
// module chunks = 3